;(function(){
	// now used for more than just events
	var resizeColumns = function() {
		console.log("resizeColumns");
		$(".resize-columns").each(function(i,eventGroup) {
			$(eventGroup).find("li").css("height", "auto");
			var tallest = 0;
			$(eventGroup).find("li").each(function(i,e) {
				if ($(e).height() > tallest) tallest = $(e).height();
			})
			$(eventGroup).find("li").height(tallest);
		});
	}

	resizeColumns();
	$(window).on("load resize orientationchange", debounce(resizeColumns, 500))
})(); 
